import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  filter,
  first,
  firstValueFrom,
  map,
  race,
} from 'rxjs';
import { corporationActions, corporationSelectors } from '@redux/corporation.effects';
import { Corporation } from '@models/customer/corporation.model';

export const corporationGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);

  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];
  console.log('🏢 CorporationGuard - Hostname:', hostname);
  console.log('🏢 CorporationGuard - Subdomain:', subdomain);
  const corporationId = route.params['corporationId'];
  console.log('🏢 CorporationGuard - CorporationId from route:', corporationId);
  
  if (!subdomain || subdomain === 'localhost' || subdomain === 'www') {
    console.log('🏢 CorporationGuard - Invalid subdomain, redirecting to 404');
    router.navigate(['/404']).then();
    return false;
  }

  if (corporationId) {
    console.log('🏢 CorporationGuard - CorporationId found in route, allowing access');
    return true;
  }

  const token = localStorage.getItem('token');
  if (token) {
    console.log('🏢 CorporationGuard - User already authenticated, redirecting to main app');
    router.navigate(['/']).then();
    return false;
  }

  console.log('🏢 CorporationGuard - Searching for corporation with subdomain:', subdomain);
  store.dispatch(corporationActions.read({
    path: 'corporations/get-by-field',
    params: { field: 'subdomain', value: subdomain }
  }));

  return firstValueFrom(
    race(
      store.select(corporationSelectors.selectModel).pipe(
        filter((corporation: Corporation | null) => !!corporation),
        first(),
        map((corporation: Corporation | null) => {
          console.log('🏢 CorporationGuard - Corporation found:', corporation);
          if (corporation) {
            console.log('🏢 CorporationGuard - Redirecting to corporation login:', `/corporation/${corporation.id}/authentication/login`);
            router.navigate([`/corporation/${corporation.id}/authentication/login`]).then();
            return false;
          } else {
            console.log('🏢 CorporationGuard - Corporation not found, redirecting to 404');
            router.navigate(['/404']).then();
            return false;
          }
        }),
      ),
      store.select(corporationSelectors.selectError).pipe(
        filter((error: string | null) => !!error),
        first(),
        map(() => {
          console.log('🏢 CorporationGuard - Error occurred, redirecting to 404');
          router.navigate(['/404']).then();
          return false;
        }),
      ),
    ),
  );
};
